// extracted by mini-css-extract-plugin
export var chevron = "_ks-2";
export var chevronRotated = "_ks-3";
export var header = "_ks-1";
export var section = "_ks-0";